import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {Field} from '../../jspb/flow_pb';
import {FormArray} from '@angular/forms';
import {FieldValue} from '../../jspb/flow_api_pb';
import {FlowField} from '../flow-field/flow-field';

@Component({
  selector: 'auto-generated-uuid-field',
  template: '',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {provide: FlowField, useExisting: AutoGeneratedUuidFieldComponent},
  ],
})
export class AutoGeneratedUuidFieldComponent implements FlowField {
  @Input() field: Field;
  @Output() focusNextField: EventEmitter<void> = new EventEmitter();

  fields: FormArray;

  ngOnInit() {
    this.fields = new FormArray([]);
  }

  reset() {}

  getFieldValue(): FieldValue | null {
    return null;
  }

  focusFirstInput() {
    this.focusNextField.emit();
  }

  addAnother() {}
}
